import { Component, ViewChild, ElementRef } from "@angular/core";
import { OnInit } from "@angular/core";

import { SessionStorageService } from "../shared/services/session-storage.service";
import { SnackbarService } from "./../shared/services/snackbar.service";
import { VCPhotoService } from "./virtual-consultation-photo-upload.service";
import { RestrictOutsideScrollService } from "./../shared/services/restrict-outside-scroll.service";
import { Router } from "@angular/router";

import {
  ImageCropperComponent,
  CropperSettings,
  Bounds,
} from "ng2-img-cropper";
import { SharedService } from "../shared/services/shared.service";

const EMERGENCY_TYPE = "vc-emergency-checkup";

@Component({
  template: require('./virtual-consultation-photo-upload.component.html'),
  styles: [require('./virtual-consultation-photo-upload.component.less')],
  preserveWhitespaces: true,
  providers: [VCPhotoService, SnackbarService],
})
export class VCPhotoUploadComponent implements OnInit {
  constructor(
    private _sessionStorageService: SessionStorageService,
    private _router: Router,
    private _mdlSnackbarService: SnackbarService,
    private _vcPhotoService: VCPhotoService,
    private _sharedService: SharedService,
    private _restrictOutsideScrollService: RestrictOutsideScrollService
  ) {}

  private _CROPDIMENTION = 500;

  @ViewChild("cropImage", { static: false }) cropImage: any;
  @ViewChild("cropper", { static: false }) cropper: ImageCropperComponent;
  @ViewChild("imagePreview", { static: false }) imagePreview: ElementRef;
  @ViewChild("canvas", { static: false }) canvasRef: ElementRef;
  @ViewChild("video", { static: false }) videoRef: ElementRef;
  @ViewChild("denyPopup", {static: false}) denyPopup: any;
  @ViewChild("spoonIllustration", {static: false}) spoonIllustration: any;

  isMobile: boolean = false;
  isSafari: boolean = false;
  illImage: any = [
    require("./../../assets/images/faceSmile.png"),
    require("./../../assets/images/teethFrontview.png"),
    require("./../../assets/images/teethFrontviewApart.png"),
    require("./../../assets/images/teethRightside.png"),
    require("./../../assets/images/teethLefttside.png"),
    require("./../../assets/images/teethUpper.png"),
    require("./../../assets/images/teethLower.png"),
  ];
  photoImage: any = null;
  data1 = {};
  cropperSettings1 = new CropperSettings();
  croppedHeight: any;
  croppedWidth: any;
  logoPreview: String;
  imageName: any;
  loading: boolean = false;
  illustrationImages: any = [];
  uploadImages: any = [];
  illustrationImagesAlignersIn: any = [];
  uploadImagesAlignersIn: any = [];
  photoIndex: number;
  imageNames = [
    "Smile",
    "Front Teeth",
    "Front Teeth - Apart",
    "Right Side",
    "Left Side",
    "Upper Teeth",
    "Lower Teeth",
  ];
  imageNamesForAligners = [
    "Front Teeth",
    "Front Teeth - Apart",
    "Right Side",
    "Left Side",
    "Upper Teeth",
    "Lower Teeth",
  ];
  _patientFile: any = {};
  fixedHeading: boolean = false;
  nextClickedClass = "";
  prevClickedClass = "";
  vcType: String = "";

  photoFromCamera: boolean = false;
  hasMobileCameraAccess: boolean = false;
  video: any;
  videoTrack: any;
  capturedImage: any;
  loadingCamera: boolean;
  context: any;
  videoDevices: any[] = [];
  cameras: string[] = [];
  mirrorCamera: boolean = false;
  cameraViewMetaItems = [
    {
      slug: "smile",
      name: "Smile",
      description: "Smile big & take a selfie looking straight into the camera",
    },
    {
      slug: "front-teeth",
      name: "Front Teeth",
      description:
        "With your lips retracted, bite down and snap a photo of your front teeth",
    },
    {
      slug: "front-teeth-apart",
      name: "Front Teeth Apart",
      description:
        "With your lips retracted, open your front teeth slightly and snap a photo of your front teeth",
    },
    {
      slug: "right-side",
      name: "Right Side View",
      description:
        "With your right lip retracted, bite down and snap a photo that includes your premolars & 1 st molars",
    },
    {
      slug: "left-side",
      name: "Left Side View",
      description:
        "With your left lip retracted, bite down and snap a photo that includes your premolars & 1 st molars",
    },
    {
      slug: "upper-teeth",
      name: "Upper Teeth",
      description:
        "With your upper lip retracted, snap a photo of the chewing surfaces of your upper teeth",
    },
    {
      slug: "lower-teeth",
      name: "Lower Teeth",
      description:
        "With your lower lip retracted, snap a photo of the chewing surfaces of your lower teeth",
    },
  ];
  cameraViewMeta: any = {};
  uploadingPhoto: boolean;
  cameraFaces = {
    FRONT: "user",
    BACK: "environment",
  };
  showFlash: boolean;
  isEmergencyPage: boolean;
  isSmileError: boolean;
  loadingCameraText: string = 'Camera is loading...';
  isAllPhotoError: boolean;
  defaultCameraId: string;
  addressBarHidden: boolean;

  ngOnInit() {
    window.onorientationchange = () => {
      this.spoonIllustration.close()
    };

    let that = this;
    window.addEventListener("scroll", function (event) {
      if (window.scrollY > (window.innerHeight * 30) / 100) {
        that.fixedHeading = true;
      } else {
        that.fixedHeading = false;
      }
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this._sessionStorageService.readItem("vcType").then((data: any) => {
      if (data) {
        this.vcType = data;
        this.isEmergencyPage = this.vcType === EMERGENCY_TYPE;
      }
    });
    this._sessionStorageService.readItem("patientFile").then((data: any) => {
      if (data) {
        this._patientFile = data;
        let previousUploadImages = false;
        let previousUploadImagesAlignersIn = false;
        if (
          this._patientFile.uploadImages &&
          this._patientFile.uploadImages.length
        ) {
          this.uploadImages = this._patientFile.uploadImages;
          previousUploadImages = true;
        }
        if (
          this._patientFile.uploadImagesAlignersIn &&
          this._patientFile.uploadImagesAlignersIn.length
        ) {
          this.uploadImagesAlignersIn = this._patientFile.uploadImagesAlignersIn;
          previousUploadImagesAlignersIn = true;
        }
        for (let i = 0; i < 7; ++i) {
          this.illustrationImages.push({
            name: this.imageNames[i],
            image: this.illImage[i],
          });
          if (!previousUploadImages)
            this.uploadImages.push({
              uploaded: false,
              image: this.photoImage,
              id: null,
            });
          if (i < 4) {
            this.illustrationImagesAlignersIn.push({
              name: this.imageNamesForAligners[i],
              image: this.illImage[i + 1],
            });
            if (!previousUploadImagesAlignersIn)
              this.uploadImagesAlignersIn.push({
                uploaded: false,
                image: this.photoImage,
                id: null,
              });
          }
        }
      } else {
        this._patientFile.photoType = 1;
        for (let i = 0; i < 7; ++i) {
          this.illustrationImages.push({
            name: this.imageNames[i],
            image: this.illImage[i],
          });
          this.uploadImages.push({
            uploaded: false,
            image: this.photoImage,
            id: null,
          });
          if (i < 4) {
            this.illustrationImagesAlignersIn.push({
              name: this.imageNamesForAligners[i],
              image: this.illImage[i + 1],
            });
            this.uploadImagesAlignersIn.push({
              uploaded: false,
              image: this.photoImage,
              id: null,
            });
          }
        }
      }
    });
    this.isMobile = this._sharedService.isMobileOrTabletDevice();
    this.isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      this.hasMobileCameraAccess = true;
    }
    this.cropperSettings1.noFileInput = true;
    this.cropperSettings1.canvasWidth = 200;
    this.cropperSettings1.canvasHeight = 200;
    this.cropperSettings1.croppedWidth = this._CROPDIMENTION;
    this.cropperSettings1.croppedHeight = this._CROPDIMENTION;
    this.cropperSettings1.width = 130;
    this.cropperSettings1.height = 130;
  }

  prevPage() {
    this.endVideoStream();
    this.prevClickedClass = "prevClickClass";
    setTimeout(() => {
      this.prevClickedClass = "";
      this._patientFile.uploadImages = this.uploadImages;
      this._patientFile.uploadImagesAlignersIn = this.uploadImagesAlignersIn;
      this._sessionStorageService.saveItem("patientFile", this._patientFile);
      if (this._patientFile.photoType === 1) {
        if (this.vcType) {
          this._router.navigate([this.vcType], { replaceUrl: true });
        }
      } else {
        this._patientFile.photoType = 1;
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }, 300);
  }

  nextPage() {
    if (this.nextClickedClass !== 'nextClickClass') {
      this.endVideoStream();
      this.nextClickedClass = "nextClickClass";
      setTimeout(() => {
        this.nextClickedClass = "";
        this._patientFile.uploadImages = this.uploadImages;
        this._patientFile.uploadImagesAlignersIn = this.uploadImagesAlignersIn;
        this._sessionStorageService.saveItem("patientFile", this._patientFile);
        let uploadedAllImages = true;
        this.isSmileError =
          this.isEmergencyPage && !this.uploadImages[0].uploaded;

        if (this.isEmergencyPage) {
          uploadedAllImages =
            this.uploadImages[0].uploaded &&
            this.uploadImages.slice(1).some((element: any) => element.uploaded);
        } else {
          if (this._patientFile.photoType === 1) {
            uploadedAllImages = this.uploadImages.every(
              (element: any) => element.uploaded
            );
          } else if (this._patientFile.photoType === 2) {
            uploadedAllImages = this.uploadImagesAlignersIn.every(
              (element: any) => element.uploaded
            );
          }
        }
        if (uploadedAllImages) {
          this.isAllPhotoError = false;
          this.endVideoStream();
          if (
            this._patientFile.has_aligner === "yes" &&
            this._patientFile.photoType === 1
          ) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            this._patientFile.photoType = 2;
          } else if (
            this._patientFile.has_aligner === "yes" &&
            this._patientFile.photoType === 2
          ) {
            this._router.navigate(["vc-patient-details"], { replaceUrl: true });
          } else if (
            this._patientFile.has_aligner === "no" ||
            !this._patientFile.has_aligner
          ) {
            this._router.navigate(["vc-patient-details"], { replaceUrl: true });
          }
        } else {
          this.isAllPhotoError = !this.isEmergencyPage;
          this._mdlSnackbarService.showSnackbar(
            this.isEmergencyPage ? "SNAP_ATLEAST_ONE" : "SNAP_ALL_PHOTOS"
          );
          setTimeout(() => {
            this._sharedService.scrollToError('.error-ele');
          }, 300);
        }
      }, 300);
    }
  }

  // get current crop height and width
  cropped(bounds: Bounds) {
    this.cropImage.show();
    this.croppedHeight = bounds.bottom - bounds.top;
    this.croppedWidth = bounds.right - bounds.left;
    this.loading = false;
  }

  setCropedImage = (data: any) => {
    this.loading = true;
    this.logoPreview = data.image;
    let file = this.dataURItoBlob(data.image);
    this.setCurrentMediaFile(file, data);
    this.cropImage.close();
  };

  dataURItoBlob(dataURI: any) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = decodeURI(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  // cancel crop
  cancelCrop = () => {
    this.cropImage.close();
  };

  endVideoStream() {
    if (this.videoTrack && this.videoTrack.readyState === "live") {
      this.videoTrack.stop();
    }
  }

  onShutterClick() {
    if (this.mirrorCamera) {
      this.showFlash = true;
      setTimeout(this.snapPhoto, 500);
    } else {
      this.snapPhoto();
    }
  }

  snapPhoto = async () => {
    const canvas = this.canvasRef.nativeElement;
    const video = this.videoRef.nativeElement;
    const possiblePhotoSize = this.getPhotoDimention(
      video.videoWidth,
      video.videoHeight
    );
    canvas.height = possiblePhotoSize;
    canvas.width = possiblePhotoSize;
    const imageContext = canvas.getContext("2d");
    this.drawImageProp(
      imageContext,
      video,
      0,
      0,
      possiblePhotoSize,
      possiblePhotoSize
    );
    this.capturedImage = canvas.toDataURL();
    if (this.mirrorCamera) {
      this.showFlash = false;
    }
  };

  resetViewfinder() {
    this.capturedImage = null;
  }

  uploadPhoto() {
    const file = this.dataURItoBlob(this.capturedImage);
    const data = {
      image: this.capturedImage,
    };
    this.imageName = `${Date.now()}-captured.png`;
    this.setCurrentMediaFile(file, data);
    this.endVideoStream();
  }

  // Converts canvas to an image
  convertCanvasToImage(canvas: any) {
    var image = new Image();
    image.src = canvas.toDataURL();
    return image;
  }

  canPlay() {
    this.loadingCamera = false;
  }

  cancel() {
    this.photoFromCamera = false;
    this.capturedImage = null;
    this.endVideoStream();
  }

  // Getting media from camera
  async initializeCamera(deviceId?: string) {
    try {
      this.loadingCameraText = "Camera is loading...";
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: deviceId || this.defaultCameraId,
          facingMode: deviceId === this.cameras[0] ? 'user' : 'environment'
        },
      });
      this.videoTrack = stream.getTracks()[0];
      this.mirrorCamera = this.isUsingFrontCam(this.videoTrack);

      // this code will only run for the first time to get device camera information
      if (!this.cameras.length) {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        this.videoDevices = mediaDevices
          .filter((m) => (m.kind === "videoinput"))
        this.cameras = this.videoDevices
          .map((v) => v.deviceId);

        //Set back cam as default
        if (this.mirrorCamera) {
          this.defaultCameraId = this.switchCamera();
          return;
        }
      }

      // Get the image requirements and apply it to the videotrack
      const constraints = this.getConstraints(this.videoTrack);
      await this.videoTrack.applyConstraints(constraints);
      this.videoRef.nativeElement.srcObject = stream;
    } catch (error) {
      const notAllowedError = error.name === "NotAllowedError";
      this.loadingCameraText = notAllowedError
        ? "Please enable <b>Camera Access</b> for this internet browser app in your device’s <b>Settings</b> in order to proceed."
        : "This feature is not supported by the device";
      this.denyPopup.show();
    }
  }

  isUsingFrontCam(videoTrack: MediaStreamTrack) {
    const trackSettings = videoTrack.getSettings();

    return trackSettings.facingMode === "user";
  }

  getPhotoDimention(width: number, height: number) {
    const maxSupportedSquareSize = width < height ? width : height;
    return maxSupportedSquareSize < this._CROPDIMENTION
      ? maxSupportedSquareSize
      : this._CROPDIMENTION;
  }

  getConstraints(videoTrack: MediaStreamTrack) {
    const trackCapabilities = videoTrack.getCapabilities();

    return this.adjustResolution({
      width: trackCapabilities.width.max,
      height: trackCapabilities.height.max,
    });
  }

  // Switch to other camera and return it's device ID
  switchCamera() {
    if (this.cameras.length < 2) return;

    let backCamInitialIndex = 0;
    for (let i = 1; i < this.videoDevices.length; ++i) {
      if (this.videoDevices[i].label.toLowerCase().indexOf('front') === -1) {
        backCamInitialIndex = i;
      }
    }

    const currentCam = this.videoTrack.getSettings();
    const currentDeviceId = currentCam.deviceId;
    const targetCam =
      currentDeviceId === this.cameras[0] ? this.cameras[backCamInitialIndex] : this.cameras[0];

    this.endVideoStream();
    setTimeout(() => this.initializeCamera(targetCam));
    return targetCam;
  }

  capturePhoto(index: number) {
    this.photoIndex = index;
    this.addressBarHidden = (window.innerHeight > document.documentElement.offsetHeight) ? true : false;

    if (this.hasMobileCameraAccess) {
      this.cameraViewMeta = this.getCameraViewMeta();
      this.photoFromCamera = true;
      this.loadingCamera = true;
      setTimeout(this.initializeCamera.bind(this), 0);
    } else {
      const cropperInput = document.getElementById(`capImg-${index}`);
      cropperInput.click();
    }
  }

  getCameraViewMeta() {
    return this.cameraViewMetaItems[
      this._patientFile.photoType === 1 ? this.photoIndex : this.photoIndex + 1
    ];
  }

  getOverlay(): string {
    const slug = this.getCameraViewMeta().slug;
    return require(`../../assets/images/overlay-${slug}.png`);
  }

  changeListener($event: any): void {
    var inputValue = $event.target;
    var image: any = new Image();
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();
    var that = this;
    myReader.onloadend = (e) => {
      // that.setCurrentMediaFile(file, {});
      that.imageName = file.name;
      console.log(file.name);
      image.src = e.target["result"];
      that.loading = true;
      setTimeout(function () {
        that["cropper"].setImage(image);
      }, 100);
    };
    myReader.readAsDataURL(file);
  }

  setCurrentMediaFile(file: any, data: any) {
    this.uploadingPhoto = true;
    let formData = new FormData();
    formData.append("image", file, this.imageName);
    this._vcPhotoService
      .uploadPhoto(formData, this._patientFile.token)
      .subscribe(
        (res: any) => {
          this.uploadingPhoto = false;
          this.loading = false;
          this.photoImage = data.image;
          if (this._patientFile.photoType === 1) {
            this.uploadImages[this.photoIndex].image = this.photoImage;
            this.uploadImages[this.photoIndex].uploaded = true;
            this.uploadImages[this.photoIndex].id = res.data.id;
            this.uploadImages[this.photoIndex].mirrored = this.mirrorCamera;
          } else {
            this.uploadImagesAlignersIn[
              this.photoIndex
            ].image = this.photoImage;
            this.uploadImagesAlignersIn[this.photoIndex].uploaded = true;
            this.uploadImagesAlignersIn[this.photoIndex].id = res.data.id;
            this.uploadImagesAlignersIn[
              this.photoIndex
            ].mirrored = this.mirrorCamera;
          }
          this.photoFromCamera = false;
          this.capturedImage = null;
          this.isSmileError =
            this.isEmergencyPage && !this.uploadImages[0].uploaded;
        },
        (error: any) => {
          this.uploadingPhoto = false;
          this.loading = false;
          this._mdlSnackbarService.showSnackbar("SOMETHING_WENT_WRONG");
        }
      );
  }

  //https://stackoverflow.com/a/21961894
  drawImageProp(
    ctx: any,
    vid: any,
    x: any,
    y: any,
    w?: any,
    h?: any,
    offsetX?: any,
    offsetY?: any
  ) {
    if (arguments.length === 2) {
      x = y = 0;
      w = ctx.canvas.width;
      h = ctx.canvas.height;
    }

    // default offset is center
    offsetX = typeof offsetX === "number" ? offsetX : 0.5;
    offsetY = typeof offsetY === "number" ? offsetY : 0.5;

    // keep bounds [0.0, 1.0]
    if (offsetX < 0) offsetX = 0;
    if (offsetY < 0) offsetY = 0;
    if (offsetX > 1) offsetX = 1;
    if (offsetY > 1) offsetY = 1;

    var iw = vid.videoWidth,
      ih = vid.videoHeight,
      r = Math.min(w / iw, h / ih),
      nw = iw * r, // new prop. width
      nh = ih * r, // new prop. height
      cx,
      cy,
      cw,
      ch,
      ar = 1;

    // decide which gap to fill
    if (nw < w) ar = w / nw;
    if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
    nw *= ar;
    nh *= ar;

    // calc source rectangle
    cw = iw / (nw / w);
    ch = ih / (nh / h);

    cx = (iw - cw) * offsetX;
    cy = (ih - ch) * offsetY;

    // make sure source rectangle is valid
    if (cx < 0) cx = 0;
    if (cy < 0) cy = 0;
    if (cw > iw) cw = iw;
    if (ch > ih) ch = ih;

    // fill image in dest. rectangle
    ctx.drawImage(vid, cx, cy, cw, ch, x, y, w, h);
  }

  adjustResolution = (resolution: any) => {
    const { width, height } = resolution;
    const smallerDimention = height < width ? "height" : "width";
    const biggerDimention = smallerDimention === "height" ? "width" : "height";
    const aspectRatio =
      resolution[biggerDimention] / resolution[smallerDimention];
    const constraints = { height, width };

    constraints[smallerDimention] =
      resolution[smallerDimention] > this._CROPDIMENTION
        ? this._CROPDIMENTION
        : resolution[smallerDimention];
    constraints[biggerDimention] = constraints[smallerDimention] * aspectRatio;
    return constraints;
  };

  ngOnDestroy() {
    this.denyPopup.close()
    this.spoonIllustration.close();
    this.cropImage.close();
  }
}
